<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        {{ title }}
        <span class="font-italic font-weight-thin">{{ subtitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot class="accordion-slot">
        <!-- Content will be injected here -->
      </slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    title: String,
    subtitle: String
  }
};
</script>

<style lang="scss">
/* Gives bottom border radious to last expansion panel label*/
div.v-card__text > div > div:last-child > button.v-expansion-panel-header {
  border-radius: 0 0 4px 4px !important;
}

.v-expansion-panel-content__wrap {
  margin: auto !important;
  // max-width: 800px !important;
  padding: 0.5rem 0 !important;
  p,
  ol,
  ul,
  img {
    font-weight: 300 !important;
    padding: 0.5rem 1rem !important;
  }
  .img-container {
    padding: 0.25rem 0;
  }
  ol > li,
  ul > li {
    margin-left: 1rem;
  }
}

//
@media only screen and (min-width: 824px) {
  .v-expansion-panel-content__wrap {
    & > * {
      margin-left: auto !important;
      margin-right: auto !important;
      width: 800px !important;
    }
  }
}

.v-expansion-panel-header,
.v-expansion-panel-content__wrap,
.v-card,
.v-card__title,
.v-card-text,
.theme--dark.v-data-table tbody tr:hover {
  background-color: #5b665b !important;
}

/* Overwrites all expansion panel content's background color */
.v-expansion-panel-content,
.v-expansion-panel-content__wrap table,
.v-expansion-panel-content__wrap,
.v-expansion-panel--active,
.v-item--active,
.v-expansion-panel-content__wrap > * {
  background-color: #444f46 !important;
}
</style>
